import { COLORS, FONTS } from '../../constants';

// eslint-disable-next-line no-unused-vars
const styles = theme => ({
  checkAuthContain: {
    padding: '70px',
    fontFamily: FONTS.PRIMARY,
    color: COLORS.GREY_DARK,
    textAlign: 'center',
    marginTop: 80,
    fontSize: '1.375rem',
  },
  spinner: {
    color: COLORS.GREEN,
  },
});

export default styles;
